{
  "auth": {
    "login": "Login",
    "loginDescription": "Please enter your username and password",
    "username": "Username",
    "password": "Password",
    "rememberMe": "Remember me",
    "forgotPassword": "Forgot password?",
    "noAccount": "Don't have an account?",
    "createAccount": "Create account",
    "usernameRequired": "Username is required",
    "passwordRequired": "Password is required",
    "loginSuccess": "Login successful",
    "loginFailed": "Login failed",
    "agree": "I agree to",
    "createNewAccount": "Create new account",
    "email": "Email",
    "recover_password": "Recover password",
    "sign_up": "Sign up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use",
    "reset_password": "Reset Password",
    "recover_password_text": "Enter your email and we'll send you a link to reset your password",
    "go_back": "Go back",
    "check_email": "Check your email",
    "check_email_text": "Please check your email for instructions on how to reset your password.",
    "back_to_login": "Back to login",
    "reset_password_text": "Enter your new password",
    "new_password": "New password",
    "confirm_password": "Confirm password",
    "password_updated": "Password Updated",
    "password_updated_text": "Your password has been updated successfully. Click the button below to login."
  },
  "menu": {
    "dashboard": "Dashboard",
    "userManagement": "User Management",
    "userList": "User List",
    "userRoles": "Role Management",
    "productManagement": "Product Management",
    "productList": "Product List",
    "productCategories": "Product Categories",
    "productBrands": "Brand Management",
    "orderManagement": "Order Management",
    "orderList": "Order List",
    "orderReturns": "Returns Management",
    "jobManagement": "Job & Seeker Management",
    "jobList": "Job List",
    "jobSeekerList": "Seeker List",
    "companyList": "Company List",
    "systemSettings": "System Settings",
    "siteSettings": "Site Settings",
    "paymentSettings": "Payment Settings",
    "shippingSettings": "Shipping Settings",
    "users": "Users",
    "projects": "Projects",
    "payments": "Payments",
    "payment-methods": "Payment Methods",
    "pricing-plans": "Pricing Plans",
    "billing": "Billing",
    "auth": "Auth",
    "login": "Login",
    "signup": "Sign Up",
    "recover-password": "Recover Password",
    "faq": "FAQ",
    "404": "404",
    "preferences": "Preferences",
    "productsDirectLink": "Products List (Direct Link)"
  },
  "messages": {
    "all": "See all messages",
    "new": "New message from {name}"
  },
  "notifications": {
    "all": "See all notifications",
    "new": "New notification from {name}"
  },
  "search": {
    "placeholder": "Search..."
  },
  "settings": {
    "language": "Language"
  }
}
